import React, { useEffect, useState, useRef } from 'react';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Once visible, we don't need to observe anymore
          if (domRef.current) observer.unobserve(domRef.current);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px'
    }) // Trigger slightly before it comes into view
;
    const currentRef = domRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);
  const getTransform = () => {
    if (isVisible) return 'translate(0, 0)';
    switch (direction) {
      case 'up':
        return 'translateY(20px)';
      case 'left':
        return 'translateX(-20px)';
      case 'right':
        return 'translateX(20px)';
      default:
        return 'translate(0, 0)';
    }
  };
  return <div ref={domRef} className={className} style={{
    opacity: isVisible ? 1 : 0,
    transform: getTransform(),
    transition: `opacity 0.6s ease-out, transform 0.6s ease-out`,
    transitionDelay: `${delay}ms`
  }} data-id="element-192">
      {children}
    </div>;
}